/* eslint-disable @angular-eslint/prefer-inject */
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CQMSTileConstants } from '../models/constants/cqms-dash.constants';
import { CQMSTileModel } from '../models/cqms-dash.model';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DateRangeDialogComponent } from '../dialogs/date-range-dialog/date-range-dialog';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-cqms-dashboard',
  imports: [
    MatIconModule,
    MatTooltipModule
],
  template: `
  <div class="page-container">
    <div class="page-title">{{cqmsTitle}}</div>

    <div class="dash-container">
    @for(tile of cqmsTileData; track tile) {
      <div class="tile-container">
        @if(tile.hasTooltip) {
          <mat-icon class="tile-tooltip" 
          [matTooltip]="tile.tooltipText"
          matTooltipPosition="above">info</mat-icon>
        }
          <button class="tile-button" [disabled]="tile.isDisabled" (click)="navigate(tile.id, tile.url)">
              <span class="material-symbols-outlined tile-icon">{{tile.icon}}</span>
              <div class="tile-text">{{tile.name}}</div>
          </button>
      </div>
    }
    </div>
  </div>
  `,
  styles: [`
    @import url('https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@24,400,1,0');

    :host {
      width: 100%;
      display: flex;
      flex-direction: column;
      column-gap: 10px;
    }

    .page-container {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
    }

    .tile-container {
      height: 218px;
    }

    .page-title {
      font-size: 65px;
      font-weight: 700;
      color: var(--tile-detail-color);
      margin-top: 20px;
      margin-bottom: 20px;
      width: 100%;
      text-align: center;
    }

    .dash-container {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      gap: 30px;
      width: 840px;
      margin-top: 20px;
    }

    .tile-tooltip {
      position: absolute;
      z-index: 10;
      color: var(--icon-warning);
      height: 42px;
      width: 42px;
      font-size: 42px;
      margin-left: 200px;
      margin-top: 10px;
    }

    .tile-button {
      height: 218px;
      width: 242px;
      background-color: var(--tile-background);
      box-shadow: 0 4px 14px 1px rgba(0, 0, 0, 0.18);
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      border-radius: 8px;

      .tile-icon {
        font-size: 100px;
        padding-bottom: 12px;
        color: var(--tile-detail-color);
      }

      .tile-text {
          font-size: 19px;
          font-weight: 700;
          width: 135px;
          color: var(--tile-detail-color);
      }
  }

  .tile-button:disabled {
      color: var(--button-disabled-color);
      cursor: not-allowed;

      .tile-icon {
        font-size: 100px;
        padding-bottom: 12px;
        color: var(--button-disabled-color);
      }

      .tile-text {
        font-size: 19px;
        font-weight: 700;
        width: 135px;
        color: var(--button-disabled-color);
      }
  }

  .tile-button:hover:not(:disabled) {
      background: var(--tile-detail-color);
      color: white;

      .tile-icon {
        font-size: 100px;
        padding-bottom: 12px;
        color: var(--tile-detail-hover);
      }

      .tile-text {
        font-size: 19px;
        font-weight: 700;
        width: 135px;
        color: var(--tile-detail-hover);
      }
  }
  `]
})
export class CqmsDashboardComponent {
  cqmsTileData: CQMSTileModel[] = this.setupTileData();
  cqmsTitle: string = this.cqmsTileConstants.title;

  constructor(
    private cqmsTileConstants: CQMSTileConstants, 
    private router: Router,
    private dialog: MatDialog
  ) {}

  navigate(id: number, url: string) {
    if (id === 4) {
      //opens tableau report in new tab
      window.open(url, '_blank');
    } else if(id === 5) {
      // open date range dialog for defect history
      this.dialog.open(DateRangeDialogComponent, {
        data: { id: 1, startDate: null, endDate: null }
      });
    } else {
      this.router.navigate([url]);
    }
  }

  setupTileData(): CQMSTileModel[] {
    const tileData: CQMSTileModel[] = [
      {
        id: 1,
        name: this.cqmsTileConstants.checklistConfigTitle,
        url: this.cqmsTileConstants.checklistConfigUrl,
        icon: 'list_alt_check',
        isDisabled: false,
        hasTooltip: false,
      },
      {
        id: 2,
        name: this.cqmsTileConstants.facilityConfigTitle,
        url: this.cqmsTileConstants.facilityConfigUrl,
        icon: 'warehouse',
        isDisabled: false,
        hasTooltip: false,
      },
      {
        id: 3,
        name: this.cqmsTileConstants.userSettingsTitle,
        url: this.cqmsTileConstants.userSettingsUrl,
        icon: 'person',
        isDisabled: false,
        hasTooltip: false,
      },
      {
        id: 4,
        name: this.cqmsTileConstants.tableauDashTitle,
        url: this.cqmsTileConstants.tableauDashUrl,
        icon: 'share',
        isDisabled: false,
        hasTooltip: false,
      },
      {
        id: 5,
        name: this.cqmsTileConstants.defectHistoryTitle,
        url: this.cqmsTileConstants.defectHistoryUrl,
        icon: 'assignment_late',
        isDisabled: false,
        hasTooltip: false
      }
    ];
    return tileData;
  }

}